import styles from './ProjectEconomyIndicators.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectEconomyIndicators = ({ props }) => {
  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])}>
      <h2 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>
        Технико-экономические показатели
      </h2>
      <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
        {props.map((item) => (
          <li className={classnames(isMobile ? [styles.item, styles.mobile] : [styles.item])} key={item.id}>
            <p className={classnames(isMobile ? [styles.text, styles.mobile] : [styles.text])}>{item.text}</p>
            <p className={classnames(isMobile ? [styles.title, styles.mobile] : [styles.title])}>{item.title}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectEconomyIndicators;
